import { variant } from 'styled-system';

export const flashPlatformVariantsProperties = {
  default: {
    color: 'info.fg',
    backgroundColor: 'info.subtle',
    borderColor: 'info.muted',
    svg: {
      color: 'info.fg',
    },
  },
  success: {
    color: 'success.fg',
    backgroundColor: 'success.subtle',
    borderColor: 'success.muted',
    svg: {
      color: 'success.fg',
    },
  },
  danger: {
    color: 'danger.fg',
    backgroundColor: 'danger.subtle',
    borderColor: 'danger.muted',
    svg: {
      color: 'danger.fg',
    },
  },
  warning: {
    color: 'attention.fg',
    backgroundColor: 'attention.subtle',
    borderColor: 'attention.muted',
    svg: {
      color: 'attention.fg',
    },
  },
  // No `highlight` variant. It had zero call sites and hardcoded `#ecff5d`, a chartreuse that
  // appeared nowhere else in the codebase — neither of the two brand yellows, just a near-miss of
  // one of them. A Flash is a status message, so its background belongs to a valence
  // (info / success / danger / attention); "highlight" named a colour rather than a state, which is
  // why nothing ever had a reason to pass it. Removed in PLT-6074.
} as const;

export type FlashPlatformVariant = keyof typeof flashPlatformVariantsProperties;

export const flashPlatformVariants = variant({ variants: flashPlatformVariantsProperties });
